'use strict';

function isBestOf2014Special(zineOrSlug) {
  if (!zineOrSlug) {
    return false;
  }

  if (zineOrSlug.slug) {
    zineOrSlug = zineOrSlug.slug;
  }

  return zineOrSlug === 'best-of-2014';
}

module.exports = isBestOf2014Special;


/** WEBPACK FOOTER **
 ** ./utils/isBestOf2014Special.js
 **/